// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"70":"dfc81bba","247":"f1342137","583":"06ca71ea","710":"d9237c70","878":"fe82557a","983":"3a037f58"}[chunkId] + ".chunk.js";
};